import { graphql, HttpResponse } from 'msw';
import { getMiniPdpProductData } from '../../components/MiniPdpModal/mockGraphql';
import type { GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables } from '../../components/MiniPdpModal/getMiniPdpProduct';
import { mockItems } from './mockData';
export const miniPdpProductHandler = graphql.query<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>('getMiniPdpProduct', ({
  variables
}) => {
  const item = mockItems.find(product => product.sku === variables.skuId);
  return HttpResponse.json({
    data: item ? getMiniPdpProductData(item) : {
      shopProductBySkuId: null
    }
  });
});